<template>
  <ToastContainer />
  <NoticeDialogHost />
  <RouterView />
  <!-- Idle session timeout (issue 265): 30 minutes without user input ends the
       session, warned a minute ahead. Shared across the suite via app-kit. -->
  <IdleLogoutGuard :authenticated="hasSession" @timeout="onIdleTimeout" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import { ToastContainer, NoticeDialogHost, IdleLogoutGuard, IDLE_LOGOUT_REASON } from '@lumi/app-kit';
import { useAccountAuthStore } from '@/stores/auth';

// The suite's idle sign-out (issue 265). The account host has no login ROUTE —
// signing out simply swaps the workspace list back for the sign-in card — so the
// bounce is a query on the home route, which is what the notice reads.
const auth = useAccountAuthStore();
const router = useRouter();
const hasSession = computed(() => Boolean(auth.token));

function onIdleTimeout() {
  auth.logout();
  void router.replace({ path: '/', query: { reason: IDLE_LOGOUT_REASON } });
}
</script>
